import React from "react";
import './sourceselectstyles.css'

export type SourceFilter = "all" | "outreach" | "research";

type SourceOption = {
    value: SourceFilter;
    label: string;
};

const SOURCE_OPTIONS: SourceOption[] = [
    { value: "all", label: "All sources" },
    { value: "outreach", label: "Outreach" },
    { value: "research", label: "Research" },
];

type SourceSelectProps = {
    source: SourceFilter;
    onSourceChange: (value: SourceFilter) => void;
};

class SourceSelectView extends React.Component<SourceSelectProps> {
    handleOptionClick = (value: SourceFilter) => {
        if (value === this.props.source) return;
        this.props.onSourceChange(value);
    };

    render() {
        const { source } = this.props;

        return <div className="source-filter">
            {SOURCE_OPTIONS.map(option => {
                const isActive = option.value === source;
                return <div
                    key={option.value}
                    className={"source-filter-option" + (isActive ? " source-filter-option-active" : "")}
                    onClick={() => this.handleOptionClick(option.value)}
                >
                    {option.label}
                </div>
            })}
        </div>
    }
}

export { SourceSelectView }